import { atom } from 'recoil';

export const isSavingPackageAtom = atom<boolean>({
    key: 'isSavingPackage',
    default: false
});
